class MultiVariantQuantity {
  constructor(container) {
    this.container = container;
    this.minTotal = parseInt(container.dataset.minTotal) || 8;
    this.totalCount = container.querySelector('.multi-variant-qty__total-count');
    this.message = container.querySelector('.multi-variant-qty__message');
    this.submitBtn = document.querySelector('.product-form__submit');

    this.i18n = {
      minMessage: container.dataset.i18nMinMessage,
    };

    // ACO's size quantity inputs, identified by the class you added
    this.acoInputs = document.querySelectorAll('.buffet-size input.wcpa_field');

    this._initObservers();
    this._update();
  }

  _initObservers() {
        // Delegate from a stable ancestor — the form or document body
        // This survives ACO replacing/cloning its own inputs
        const form = document.querySelector('.product-form')
                    || document.querySelector('form[action="/cart/add"]')
                    || document.body;

        form.addEventListener('input', (e) => {
            if (e.target.closest('.buffet-size')) {
            this._update();
            }
        });

        form.addEventListener('change', (e) => {
            if (e.target.closest('.buffet-size')) {
            this._update();
            }
        });

        // Re-query inputs on each update in case ACO replaced the nodes
        // (don't cache this.acoInputs — always read fresh)
    }

    _getTotal() {
        // Always query fresh — never rely on cached references
        const inputs = document.querySelectorAll('.buffet-size input.wcpa_field');
        let total = 0;
        inputs.forEach(input => {
            const val = parseInt(input.value);
            if (!isNaN(val) && val > 0) total += val;
        });
        return total;
    }

  _update() {
    const total = this._getTotal();
    

    this.totalCount.textContent = total;

    const ready = total >= this.minTotal;
    if (this.submitBtn) {
      this.submitBtn.disabled = !ready;
      this.submitBtn.setAttribute('aria-disabled', String(!ready));
    }

    this.message.textContent = ready ? '' : this.i18n.minMessage;
  }
}

document.querySelectorAll('.multi-variant-qty').forEach(el => {
  new MultiVariantQuantity(el);
});